export const environment = {
  production: true,
  deployment: 'UAT',
  app: {
    mainOrigin: 'https://uat.voxrapp.com',
    serviceUrl: 'https://uat.api.voxrapp.com',
    websocketUrl: 'wss://uat.api.voxrapp.com'
  },
  firebaseConfig: {
    apiKey: "AIzaSyDLfJhcXhIlxdEeXbDDbpcQH5gU6_ECeQw",
    authDomain: "second-inquiry-409607.firebaseapp.com",
    projectId: "second-inquiry-409607",
    storageBucket: "second-inquiry-409607.appspot.com",
    messagingSenderId: "410709647396",
    appId: "1:410709647396:web:c49198120c2ebefe4378b1"
  },
  recaptcha: { siteKey: "6LcdQJErAAAAACIGVJNjmpeh8dMmt1M1f5za0sLJ" },
  vapi: {
    publicKey: 'b1c5aac2-f1d2-4fd3-b7b9-ad73fd54bb20'
  },
  integrations: {
    ghl: {
      authUrl: 'https://marketplace.leadconnectorhq.com/oauth/chooselocation',
      redirectUrl: '/integration/auth-gh',
      clientId: '66d2ab7fcb1ad86ae7a0eb71-m0hq24xe',
      adminClientId: '683a99574a7b3da40afdf187-mbbubdc5',
      scopes: ['locations.readonly', 'businesses.readonly', 'companies.readonly', 'contacts.readonly', 'contacts.write', 'conversations.write', 'conversations/message.write', 'locations/customFields.readonly', 'locations/customFields.write', 'locations/tags.readonly', 'locations/tags.write', 'opportunities.write', 'opportunities.readonly', 'calendars.readonly', 'calendars.write', 'calendars/events.readonly', 'calendars/events.write', 'users.readonly', 'workflows.readonly']
    }
  }
};
